var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"2","offset":"2"}},[_c('v-btn',{attrs:{"block":"","loading":_vm.loading},on:{"click":_vm.back}},[_vm._v("Wróć do szkolenia")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }